<template>
  <div class="terms-conditions">
    <info-block @close="close">
      <template #header>
        {{ $t("termsConditionsHeader") }}
      </template>
      <template #title>
        {{ $t("termsConditionsTitle") }}
      </template>
      {{ $t("termsConditionsText") }}
    </info-block>
  </div>
</template>

<script>
import InfoBlock from "./InfoBlock";

export default {
  name: "TermsConditions",
  components: {
    InfoBlock,
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="stylus" scoped>
.terms-conditions {
  color: #000;
  font-weight: normal;
}
</style>
